import React from "react";
import ImageGallery from "react-image-gallery";
import { CDN_BASE_URL } from "../../config";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const ProductSlider = ({ data, img, name }) => {
  const array = [];
  img && array.push(img);
  data?.map((e) => {
    array.push(e);
  });
  const images =
    array.length &&
    array?.map((src) => {
      return {
        original: src,
        thumbnail: src,
      };
    });

  return (
    <div dir="ltr" class=" pd-wrap">
      <div id="pd-o-initiate " className="">
        <ImageGallery
          items={
            images.length
              ? images
              : [{ original: "/no-image.jpg", thumbnail: "/no-image.jpg" }]
          }
          renderLeftNav={(onClick, disabled) => (
            <FaAngleLeft
              className="absolute cursor-pointer top-[48%] bg-[--brand] w-[32px] h-[32px] flex pr-[1px] justify-center items-center text-[18px] m-0 text-white rounded-full left-2 z-10"
              onClick={onClick}
            />
          )}
          renderRightNav={(onClick, disabled) => (
            <FaAngleRight
              className="absolute top-[48%] cursor-pointer bg-[--brand] w-[32px] h-[32px] flex pl-[1px] justify-center items-center text-[18px] m-0 text-white rounded-full right-2 z-10"
              onClick={onClick}
            />
          )}
          renderItem={(event) => {
            if (event?.original?.img_webp) {
              return (
                <picture>
                  <source
                    type="image/webp"
                    srcset={CDN_BASE_URL + event?.original?.img_webp}
                  />
                  <img
                    src={CDN_BASE_URL + event?.original?.img_jpg}
                    alt={name}
                    loading={"lazy"}
                    className="image-gallery-image"
                  />
                </picture>
              );
            } else {
              return (
                <img
                  src={CDN_BASE_URL + event?.original}
                  alt={name}
                  loading={"lazy"}
                  className="image-gallery-image"
                />
              );
            }
          }}
          renderThumbInner={(event) => {
            if (event?.thumbnail?.img_webp) {
              return (
                <picture>
                  <source
                    type="image/webp"
                    srcset={CDN_BASE_URL + event?.thumbnail?.img_webp}
                  />
                  <img
                    src={CDN_BASE_URL + event?.thumbnail?.img_jpg}
                    alt={name}
                    loading={"lazy"}
                    className="image-gallery-thumbnail-image"
                  />
                </picture>
              );
            } else {
              return (
                <img
                  src={CDN_BASE_URL + event?.thumbnail}
                  alt={name}
                  loading={"lazy"}
                  className="image-gallery-thumbnail-image"
                />
              );
            }
          }}
        />
      </div>
    </div>
  );
};

export default ProductSlider;
